





import { defineComponent } from '@vue/composition-api'

// ================================
// Props
// ================================
export type MovieInfoBackDropProps = {
  backdropPath: string;
}

// ================================
// Component
// ================================
export default defineComponent({
  name: 'MovieInfoBackDrop',
  props: ['backdropPath'],
  setup (props: MovieInfoBackDropProps) {
    return {
      props
    }
  }
})
